import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export function generateTask() {
  const middle = randomInt(-8, 12);
  const r = randomInt(1, 6) * (Math.random() < 0.5 ? -1 : 1);
  const index = randomInt(2, 6);
  return {
    type: "ArithmeticMiddleTermTask",
    data: { index, left: middle - r, right: middle + r, middle },
  };
}

export function renderTask({ data }) {
  return (
    <p>
      W ciągu arytmetycznym <InlineMath math={`a_{${data.index - 1}}=${data.left}`} /> oraz{" "}
      <InlineMath math={`a_{${data.index + 1}}=${data.right}`} />. Oblicz wyraz{" "}
      <InlineMath math={`a_${data.index}`} />.
    </p>
  );
}

export function renderInput({ data }, userAnswer, onChange, disabled) {
  return <FractionInput label={`a_${data.index}`} value={userAnswer} onChange={onChange} disabled={disabled} />;
}

export function checkAnswer({ data }, userAnswer) {
  return Number.isFinite(userAnswer?.parsed) && Math.abs(userAnswer.parsed - data.middle) < 0.01;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`a_${data.index}=${data.middle}`} />;
}

export function renderExplanation({ data }) {
  return (
    <div className="space-y-3">
      <p>Dla trzech kolejnych wyrazów ciągu arytmetycznego wyraz środkowy jest ich średnią arytmetyczną.</p>
      <BlockMath math={String.raw`a_${data.index}=\frac{a_{${data.index - 1}}+a_{${data.index + 1}}}{2}`} />
      <BlockMath math={String.raw`a_${data.index}=\frac{${data.left}+(${data.right})}{2}=${data.middle}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer, task) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`a_${task?.data?.index ?? "n"}=${userAnswer.raw}`} />;
}
